import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const activityData = [
  { month: "Jun", value: 2 },
  { month: "Jul", value: 3.2 },
  { month: "Aug", value: 4 },
  { month: "Sep", value: 3.1 },
  { month: "Oct", value: 5.8 },
  { month: "Nov", value: 6.4 },
];

export default function ActivityChart() {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-6 h-full">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h2 className="font-bold text-gray-900">Project Activity</h2>
          <p className="text-sm text-gray-500">Prototypes submitted per month</p>
        </div>
        <button className="text-xs font-semibold border border-gray-200 rounded-full px-4 py-1.5">
          Last 6 months
        </button>
      </div>

      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={activityData}>
          <defs>
            <linearGradient id="activityFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#7c3aed" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#7c3aed" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
          <XAxis dataKey="month" tickLine={false} axisLine={false} tick={{ fontSize: 12, fill: "#9ca3af" }} />
          <YAxis tickLine={false} axisLine={false} tick={{ fontSize: 12, fill: "#9ca3af" }} />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#7c3aed"
            strokeWidth={2.5}
            fill="url(#activityFill)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}